<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/diary')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>

<!-- Lista esercizi filtrati -->
<div class="container" *ngIf="!loader && filteredExercises.length > 0">
  <h2>{{"DIARY.EXERCISE-TRACKER" | translate}}</h2>

  <!-- Campo di ricerca -->
  <mat-form-field>
    <input
      matInput
      type="text"
      placeholder="{{'GENERIC.SEARCH' | translate}}"
      [(ngModel)]="searchCtrl"
      (ngModelChange)="filterExercises()"
      required
    />
  </mat-form-field>

  <!-- Lista esercizi -->
  <div class="exercise" *ngFor="let exercise of filteredExercises" (click)="openModalExerciseDetail(exercise)">
    <span class="exercise-content">
      <div class="exercise-thumbnail">
        <img [src]="environment.exercises + '/' + exercise.exerciseId + '/images/main'" alt="Exercise Image">
      </div>
      <p>{{exercise.exerciseName[translate.currentLang.toUpperCase()]}}</p>
    </span>
    <mat-icon svgIcon="mat:arrow_forward_ios"></mat-icon>
  </div>
</div>

<!-- Nessun esercizio disponibile -->
<div class="container" *ngIf="!loader && filteredExercises.length < 1">
  <h2>{{"DIARY.EXERCISE-TRACKER" | translate}}</h2>
  <p class="no-content">{{"DIARY.NO-CONTENT" | translate}}</p>
</div>

<!-- Stato di caricamento -->
<div class="container" *ngIf="loader">
  <h2>{{"DIARY.EXERCISE-TRACKER" | translate}}</h2>

  <mat-form-field>
    <input
      matInput
      type="text"
      placeholder="{{'GENERIC.SEARCH' | translate}}"
      required
    />
  </mat-form-field>

  <div class="exercise skeleton" *ngFor="let exercise of exercisesPlaceholder"></div>
</div>
